// extracted by mini-css-extract-plugin
export var testimonialCard__icon = "testimonial-card-module--testimonial-card__icon--HGcDl";
export var testimonialCard__content = "testimonial-card-module--testimonial-card__content--fVVm4";
export var testimonialCard__author = "testimonial-card-module--testimonial-card__author--2t7PC";
export var testimonialCard__logo = "testimonial-card-module--testimonial-card__logo--ijtmA";